import React, { useEffect } from 'react';

import { WIDGET_MODAL_TYPE } from 'common/Widgets/Widget/constants';
import { useAppSelector } from 'store/hook';
import { ContractType } from 'types/contracts';

import { useCommunityViewWidgetModalContext } from './CommunityViewWidgetModalContext';
import CommunityViewWidgetModalSelector from './CommunityViewWidgetModalSelector';

const CommunityViewWidgetModalContractBenefitsFilter = () => {
  const { contracts } = useAppSelector((state) => state.global);
  const { contractTypes, modalType, setContractTypes } = useCommunityViewWidgetModalContext();

  useEffect(() => {
    if (modalType === WIDGET_MODAL_TYPE.ADD && contracts?.length && !contractTypes.length) {
      setContractTypes(contracts.map((contract: ContractType) => contract.id));
    }
  }, [contracts, modalType, contractTypes.length, setContractTypes]);

  const options =
    contracts?.map((item: ContractType) => ({
      label: item.name,
      value: item.id,
    })) ?? [];

  return (
    <CommunityViewWidgetModalSelector
      title="Contract Types"
      options={options}
      onSelect={setContractTypes}
      value={contractTypes}
    />
  );
};

export default CommunityViewWidgetModalContractBenefitsFilter;
